import { SabreFOPCodes } from '@/app/(main)/client-detail/consts/client-detail';
import type { CardType } from '@/app/(main)/client-detail/types';

/**
 * Formats credit card data in Sabre GDS FOP (Form of Payment) format
 * Format: 5-*VI4111111111111234¥12/26 (full number) or 5-*VIXXXXXXXXXXXX1234¥12/26 (masked)
 * Where:
 * - 5-* indicates to Sabre that this is a card payment
 * - VI/CA/AX/DS two-letter card type code
 * - Card number without spaces (full or masked with X)
 * - ¥ (cross of Lorraine) field separator
 * - MM/YY expiry date with slash
 * 
 * @param cardType - Type of credit card (Visa, MasterCard, AmericanExpress, Discover)
 * @param cardNumber - Full card number (if available) or last 4 digits
 * @param expiryDate - Expiry date in MM/YY format
 * @returns Formatted Sabre FOP string
 */
export function formatSabreFOP(cardType: CardType, cardNumber: string, expiryDate: string): string {
  const sabreCode = SabreFOPCodes[cardType] || SabreFOPCodes.unknown;
  
  // Remove spaces from card number
  const cleanCardNumber = cardNumber.replace(/\s/g, '');
  
  // Check if we have full card number (15-16 digits) or just last 4
  let cardNumberPart: string;
  if (cleanCardNumber.length >= 15) {
    // Full card number available
    cardNumberPart = cleanCardNumber;
  } else {
    // Only last 4 digits - mask the rest
    const cardLength = cardType === 'AmericanExpress' ? 15 : 16;
    const hiddenDigitsCount = cardLength - cleanCardNumber.length;
    const hiddenDigits = 'X'.repeat(hiddenDigitsCount);
    cardNumberPart = hiddenDigits + cleanCardNumber;
  }
  
  // Expiry date keeps MM/YY format with slash
  
  return `5-*${sabreCode}${cardNumberPart}¥${expiryDate}`;
}
